import type { Fixture, Player, TransferCandidate } from '../types';

export const rosterSource = {
  publisher: 'Manchester United',
  checkedAt: '2026-07-26T12:00:00Z',
  url: 'https://www.manutd.com/en/teams/mens-team',
};

export const players: Player[] = [
  { id: 'altay-bayindir', name: 'Altay Bayındır', shortName: 'Bayındır', number: 1, group: 'GK', roles: ['GK'] },
  { id: 'karl-darlow', name: 'Karl Darlow', shortName: 'Darlow', number: 12, group: 'GK', roles: ['GK'] },
  { id: 'tom-heaton', name: 'Tom Heaton', shortName: 'Heaton', number: 22, group: 'GK', roles: ['GK'] },
  { id: 'senne-lammens', name: 'Senne Lammens', shortName: 'Lammens', number: 31, group: 'GK', roles: ['GK'] },
  { id: 'dermot-mee', name: 'Dermot Mee', shortName: 'Mee', number: 45, group: 'GK', roles: ['GK'] },
  { id: 'andre-onana', name: 'Andre Onana', shortName: 'Onana', number: 24, group: 'GK', roles: ['GK'], selectable: false, status: 'On loan' },
  { id: 'harry-amass', name: 'Harry Amass', shortName: 'Amass', number: 41, group: 'DEF', roles: ['LB'] },
  { id: 'patrick-dorgu', name: 'Patrick Dorgu', shortName: 'Dorgu', number: 13, group: 'DEF', roles: ['LB', 'LWB'] },
  { id: 'diogo-dalot', name: 'Diogo Dalot', shortName: 'Dalot', number: 2, group: 'DEF', roles: ['RB', 'LB', 'RWB'] },
  { id: 'matthijs-de-ligt', name: 'Matthijs de Ligt', shortName: 'De Ligt', number: 4, group: 'DEF', roles: ['CB'] },
  { id: 'tyler-fredricson', name: 'Tyler Fredricson', shortName: 'Fredricson', number: 33, group: 'DEF', roles: ['CB'] },
  { id: 'ayden-heaven', name: 'Ayden Heaven', shortName: 'Heaven', number: 26, group: 'DEF', roles: ['CB'] },
  { id: 'harry-maguire', name: 'Harry Maguire', shortName: 'Maguire', number: 5, group: 'DEF', roles: ['CB'] },
  { id: 'lisandro-martinez', name: 'Lisandro Martínez', shortName: 'Martínez', number: 6, group: 'DEF', roles: ['CB', 'LB'] },
  { id: 'noussair-mazraoui', name: 'Noussair Mazraoui', shortName: 'Mazraoui', number: 3, group: 'DEF', roles: ['RB', 'LB', 'CB'] },
  { id: 'luke-shaw', name: 'Luke Shaw', shortName: 'Shaw', number: 23, group: 'DEF', roles: ['LB', 'CB'] },
  { id: 'leny-yoro', name: 'Leny Yoro', shortName: 'Yoro', number: 15, group: 'DEF', roles: ['CB', 'RB'] },
  { id: 'toby-collyer', name: 'Toby Collyer', shortName: 'Collyer', number: 43, group: 'MID', roles: ['DM', 'CM'] },
  { id: 'bruno-fernandes', name: 'Bruno Fernandes', shortName: 'Bruno', number: 8, group: 'MID', roles: ['AM', 'CM'] },
  { id: 'jack-fletcher', name: 'Jack Fletcher', shortName: 'J. Fletcher', number: 38, group: 'MID', roles: ['CM', 'AM'] },
  { id: 'tyler-fletcher', name: 'Tyler Fletcher', shortName: 'T. Fletcher', number: 39, group: 'MID', roles: ['CM', 'DM'] },
  { id: 'kobbie-mainoo', name: 'Kobbie Mainoo', shortName: 'Mainoo', number: 37, group: 'MID', roles: ['CM', 'DM'] },
  { id: 'mason-mount', name: 'Mason Mount', shortName: 'Mount', number: 7, group: 'MID', roles: ['AM', 'CM', 'LW'] },
  { id: 'andrey-santos', name: 'Andrey Santos', shortName: 'Santos', number: 17, group: 'MID', roles: ['CM', 'DM'] },
  { id: 'youri-tielemans', name: 'Youri Tielemans', shortName: 'Tielemans', number: 18, group: 'MID', roles: ['CM', 'DM'] },
  { id: 'manuel-ugarte', name: 'Manuel Ugarte', shortName: 'Ugarte', number: 25, group: 'MID', roles: ['DM', 'CM'] },
  { id: 'matheus-cunha', name: 'Matheus Cunha', shortName: 'Cunha', number: 10, group: 'FWD', roles: ['LW', 'AM', 'ST'] },
  { id: 'amad', name: 'Amad', shortName: 'Amad', number: 16, group: 'FWD', roles: ['RW', 'AM', 'RWB'] },
  { id: 'shea-lacey', name: 'Shea Lacey', shortName: 'Lacey', number: 61, group: 'FWD', roles: ['RW', 'AM'] },
  { id: 'bryan-mbeumo', name: 'Bryan Mbeumo', shortName: 'Mbeumo', number: 19, group: 'FWD', roles: ['RW', 'ST'] },
  { id: 'marcus-rashford', name: 'Marcus Rashford', shortName: 'Rashford', group: 'FWD', roles: ['LW', 'ST'] },
  { id: 'benjamin-sesko', name: 'Benjamin Šeško', shortName: 'Šeško', number: 30, group: 'FWD', roles: ['ST'] },
  { id: 'joshua-zirkzee', name: 'Joshua Zirkzee', shortName: 'Zirkzee', number: 11, group: 'FWD', roles: ['ST', 'AM'] },
];

export const nextFixture: Fixture = {
  id: 'friendly-atletico-2026-08-01',
  opponent: 'Atlético Madrid',
  competition: 'Pre-season friendly',
  venue: 'Strawberry Arena, Solna',
  date: '2026-08-01',
  kickoff: 'TBC',
  sourceUrl: 'https://www.premierleague.com/en/news/4606700/premier-league-clubs-2026-pre-season-fixtures-and-results',
};

export const transferCandidates: TransferCandidate[] = [
  {
    id: 'eduardo-camavinga',
    name: 'Eduardo Camavinga',
    club: 'Real Madrid',
    role: 'Holding / progressive midfielder',
    score: 58,
    band: 'Credible interest',
    cover: 'gold-cut',
    status: 'Identified as a midfield signing',
    summary: 'United have identified Camavinga and Real Madrid may listen to offers, but the player is believed to prefer staying.',
    friction: 'Player preference and Real Madrid’s final squad plan remain substantial barriers.',
    signals: [
      { label: 'Source quality', value: 27, note: 'Fresh Guardian reporting' },
      { label: 'Deal specificity', value: 16, note: 'Identified target, not talks' },
      { label: 'Recency', value: 14, note: 'Reported 23 July' },
      { label: 'Squad fit', value: 17, note: 'High-level No 6/8 profile' },
      { label: 'Market friction', value: -16, note: 'Favours staying at Madrid' },
    ],
    sources: [{ publisher: 'The Guardian', published: '2026-07-23', url: 'https://www.theguardian.com/football/2026/jul/23/manchester-united-consider-eduardo-camavinga-sander-berge-midfield-overhaul', detail: 'United identified Camavinga; Real may listen above €50m.' }],
  },
  {
    id: 'sander-berge',
    name: 'Sander Berge',
    club: 'Fulham',
    role: 'Holding midfielder',
    score: 55,
    band: 'Credible interest',
    cover: 'mono-type',
    status: 'Identified as a midfield signing',
    summary: 'The freshest reporting names Berge directly, with a known approximate price and extensive Premier League experience.',
    friction: 'No reported bid or talks, and Fulham’s valuation is around £40m.',
    signals: [
      { label: 'Source quality', value: 27, note: 'Fresh Guardian reporting plus Sky shortlist' },
      { label: 'Deal specificity', value: 15, note: 'Identified target' },
      { label: 'Recency', value: 14, note: 'Reported 23 July' },
      { label: 'Squad fit', value: 13, note: 'Experienced defensive midfield option' },
      { label: 'Market friction', value: -14, note: 'No active negotiation marker' },
    ],
    sources: [
      { publisher: 'The Guardian', published: '2026-07-23', url: 'https://www.theguardian.com/football/2026/jul/23/manchester-united-consider-eduardo-camavinga-sander-berge-midfield-overhaul', detail: 'United identified Berge; approximate £40m cost reported.' },
      { publisher: 'Sky Sports', published: '2026-07-03', url: 'https://www.skysports.com/football/news/11667/13559979/man-utd-transfer-news-aurelien-tchouameni-and-alex-scott-high-on-midfield-shortlist-with-ayyoub-bouaddi-also-of-interest', detail: 'Previously included on United’s midfield shortlist.' },
    ],
  },
  {
    id: 'alex-scott',
    name: 'Alex Scott',
    club: 'AFC Bournemouth',
    role: 'Progressive midfielder',
    score: 49,
    band: 'Active shortlist',
    cover: 'red-grid',
    status: 'Remains on the possible-midfielder list',
    summary: 'Scott remains in the current candidate set and was previously described as a high-priority option, but Bournemouth do not want to sell.',
    friction: 'Strong selling-club resistance and a likely premium fee.',
    signals: [
      { label: 'Source quality', value: 28, note: 'Guardian and Sky reporting' },
      { label: 'Deal specificity', value: 13, note: 'Current list; earlier high priority' },
      { label: 'Recency', value: 12, note: 'Reconfirmed 23 July' },
      { label: 'Squad fit', value: 14, note: 'Ball-carrying central profile' },
      { label: 'Market friction', value: -18, note: 'Bournemouth do not want to sell' },
    ],
    sources: [
      { publisher: 'The Guardian', published: '2026-07-23', url: 'https://www.theguardian.com/football/2026/jul/23/manchester-united-consider-eduardo-camavinga-sander-berge-midfield-overhaul', detail: 'Scott remains on United’s list.' },
      { publisher: 'Sky Sports', published: '2026-07-03', url: 'https://www.skysports.com/football/news/11667/13559979/man-utd-transfer-news-aurelien-tchouameni-and-alex-scott-high-on-midfield-shortlist-with-ayyoub-bouaddi-also-of-interest', detail: 'Earlier described as a high-priority target; Bournemouth resistant.' },
    ],
  },
  {
    id: 'manu-kone',
    name: 'Manu Koné',
    club: 'AS Roma',
    role: 'Ball-winning midfielder',
    score: 44,
    band: 'Current shortlist',
    cover: 'red-orbit',
    status: 'Included on the possible-midfielder list',
    summary: 'Koné appears in the freshest reliable shortlist, but the reporting does not yet indicate contact, a bid or negotiations.',
    friction: 'Only list-level evidence is currently available.',
    signals: [
      { label: 'Source quality', value: 27, note: 'Fresh Guardian reporting' },
      { label: 'Deal specificity', value: 9, note: 'List-level interest' },
      { label: 'Recency', value: 14, note: 'Reported 23 July' },
      { label: 'Squad fit', value: 13, note: 'Physical ball-winning profile' },
      { label: 'Market friction', value: -19, note: 'No active deal marker' },
    ],
    sources: [{ publisher: 'The Guardian', published: '2026-07-23', url: 'https://www.theguardian.com/football/2026/jul/23/manchester-united-consider-eduardo-camavinga-sander-berge-midfield-overhaul', detail: 'Koné included on United’s possible-midfielder list.' }],
  },
  {
    id: 'lewis-hall',
    name: 'Lewis Hall',
    club: 'Newcastle United',
    role: 'Left-back / wing-back',
    score: 38,
    band: 'Monitoring',
    cover: 'black-stripe',
    status: 'Monitored; pursuit previously on hold',
    summary: 'Hall is a credible left-back option, but midfield remains the priority and Newcastle have little incentive to sell.',
    friction: 'Pursuit is secondary to midfield recruitment and the player is under contract to 2029.',
    signals: [
      { label: 'Source quality', value: 27, note: 'Guardian and Sky reporting' },
      { label: 'Deal specificity', value: 8, note: 'Monitoring, not negotiations' },
      { label: 'Recency', value: 12, note: 'Reported 20 July' },
      { label: 'Squad fit', value: 12, note: 'Long-term left-back profile' },
      { label: 'Market friction', value: -21, note: 'On hold and difficult seller' },
    ],
    sources: [
      { publisher: 'The Guardian', published: '2026-07-20', url: 'https://www.theguardian.com/football/2026/jul/20/joao-gomes-signs-aston-villa-lewis-hall-antonee-robinson-manchester-united-transfer-latest', detail: 'United monitoring Hall as a left-back option.' },
      { publisher: 'Sky Sports', published: '2026-07-03', url: 'https://www.skysports.com/football/news/11667/13559979/man-utd-transfer-news-aurelien-tchouameni-and-alex-scott-high-on-midfield-shortlist-with-ayyoub-bouaddi-also-of-interest', detail: 'Pursuit described as on hold pending midfield recruitment.' },
    ],
  },
  {
    id: 'antonee-robinson',
    name: 'Antonee Robinson',
    club: 'Fulham',
    role: 'Left-back',
    score: 32,
    band: 'Monitoring',
    cover: 'cream-wave',
    status: 'Monitored as a left-back option',
    summary: 'Robinson is in the credible monitoring set, but the same report notes that his age falls outside United’s preferred profile.',
    friction: 'Age-profile mismatch and no evidence of active negotiation.',
    signals: [
      { label: 'Source quality', value: 25, note: 'Guardian reporting' },
      { label: 'Deal specificity', value: 8, note: 'Monitoring only' },
      { label: 'Recency', value: 12, note: 'Reported 20 July' },
      { label: 'Squad fit', value: 9, note: 'Immediate Premier League readiness' },
      { label: 'Market friction', value: -22, note: 'Age profile and no active talks' },
    ],
    sources: [{ publisher: 'The Guardian', published: '2026-07-20', url: 'https://www.theguardian.com/football/2026/jul/20/joao-gomes-signs-aston-villa-lewis-hall-antonee-robinson-manchester-united-transfer-latest', detail: 'United monitoring Robinson; age noted as outside preferred profile.' }],
  },
];

export const sourceMethodology = [
  'Official club and competition sources define roster and fixtures.',
  'Reuters, BBC, Sky Sports and The Guardian are accepted transfer-signal sources.',
  'The score is a transparent evidence index, not an insider claim or calibrated betting probability.',
  'List-level interest scores below active talks, bids, medicals and official announcements.',
  'A failed live check temporarily removes six points per cited page; a healthy check never adds points to old reporting.',
];
